import React from 'react'
import { Button } from './styles'

const UploadExcel = () => {
   return <Button>Upload Excel file</Button>
}

export default UploadExcel